import React, {Component} from 'react'
import { connect } from 'react-redux'
import SideDirectory from 'components/landing/SideDirectory'
import LeaveMessage from 'components/landing/LeaveMessage'
import Hero from 'components/hero/Hero'
import Feature from 'components/landing/Feature'
import Pricing from 'components/landing/Pricing'
import Footer from 'components/footer/Footer'
import ApplyForm from 'components/careers/ApplyForm'
import {Helmet} from 'react-helmet'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import scrollIntoView from 'scroll-into-view'
import Fade from 'react-reveal/Fade'
import {
  isIE
} from "react-device-detect"

class About extends Component {

  render () {
    return (
      <div style={{position: 'relative'}}>
        <Helmet>
            <title>About &#8212; OwlGo</title>
        </Helmet>
       {/* {!isIE ? <LeaveMessage /> : null}*/}
        <div className='hero--container' style={{paddingTop: '85.8px'}}>
          <div className='d-flex align-items-center hero--content-container' id='landing-page-hero'>
            <div className='container-fluid px-md-5 px-3'>
              <div className='row'>
                <div className='col-lg-6 d-sm-flex align-items-center justify-content-center'>
                  <div className='hero--col--text-container'>
                    <h1 className='mt-md-0 mt-3 mb-2 hero--col--h1'>OWLGO</h1>
                    <h2 className='mb-4 hero--col--h2'>About Us</h2>
                    <h3 className='mb-4 hero--col--h3'>OwlGo delivers a seamless event experience by empowering event organizers <b>before, during and after</b> an event.</h3>
                    {/*<div className='d-sm-flex flex-row justify-content-start'>
                      <Link to='/enquiry' className='mb-3 mr-3'>
                        <button className='btn btn-primary d-flex align-items-center'>
                          <span className='pr-5'>Join now</span>
                          <img alt='' src='img/button-arrow.svg' style={{width: '10.4px', height: '12px'}} />
                        </button>
                      </Link>*/}
                      {/*<HashLink exact to='/#features' className='mb-3' scroll={el =>  scrollIntoView(el,{ time:700, align:{top:0, left: 0}})}>
                        <button className='btn btn-secondary d-flex align-items-center'>
                          <span className='pr-5'>Learn More</span>
                          <img alt='' src='img/button-arrow.svg' style={{width: '10.4px', height: '12px'}} />
                        </button>
                      </HashLink>*/}
                    {/*</div>*/}
                  </div>
                </div>
                <div className='col-lg-6 text-center'>
                  <img className='hero--col--image' alt='header' src='img/owlgo-6.png' />
                </div>

              </div>
            </div>
          </div>
        </div>
          <div className='my-5 py-5'>
            <Fade distance={'50px'} duration={600} bottom>
              <h2 className='mb-4 pt-5 text-center'>WHY OWLGO?</h2>
              <div className='px-4 pb-5' style={{maxWidth: '700px', margin: 'auto'}}>
                We understand the hassle and pain points that come along with managing events. As a result, we made it easier by simplifying the organisation process and empowering you to improve your events!
              </div>
              <div className='px-4 pb-5' style={{maxWidth: '700px', margin: 'auto'}}>
                Gone are the days of human errors when managing your event guests. We facilitate this process, and more!
              </div>
            </Fade>
          </div>
          {/*<div className='my-5 py-5'>
            <Fade distance={'50px'} duration={600} bottom>
              <h2 className='mb-4 pt-5 text-center'>MEET OWLGO</h2>
              <div className='px-4 pb-5' style={{maxWidth: '700px', margin: 'auto'}}>
                Gone are the days of human errors when managing your event guests. We facilitate this process, and more!
              </div>
            </Fade>
          </div>*/}
        <Footer />
      </div>
    )
  }

}

const mapStateToProps = ( state, props ) => ({
    routerHash: state.router.location.hash,
})

const mapDispatchToProps ={

    }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(About)




// WEBPACK FOOTER //
// ./src/croutes/about/index.js